import { useMutation, useQueryClient } from '@tanstack/react-query';

import api from '@/hooks/useApi';

import { tokenKeys } from './useTokens';

// ============================================================================
// Types
// ============================================================================

export interface RedeemGiftCodeResponse {
  success: boolean;
  tokensGranted: number;
  newBalance: number;
}

// ============================================================================
// Hooks
// ============================================================================

/**
 * Redeem a gift code to receive tokens
 */
export function useRedeemGiftCode() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (code: string) => {
      const response = await api.post<RedeemGiftCodeResponse>('/gift-codes/redeem', { code });
      return response.data;
    },
    onSuccess: () => {
      // Invalidate token balance so it refetches with new tokens
      queryClient.invalidateQueries({ queryKey: tokenKeys.balance() });
      queryClient.invalidateQueries({ queryKey: tokenKeys.history() });
    },
  });
}
